var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneGrey26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75751 1.16947L2.63393 0.293044C3.02446 -0.09748 3.65762 -0.0974807 4.04814 0.293044L6.84446 3.08936C7.23498 3.47988 7.23498 4.11305 6.84446 4.50357L4.92049 6.42754C4.60588 6.74215 4.52788 7.22278 4.72686 7.62074C5.87713 9.92128 7.74254 11.7867 10.0431 12.937C10.441 13.1359 10.9217 13.0579 11.2363 12.7433L13.1602 10.8194C13.5508 10.4288 14.1839 10.4288 14.5745 10.8194L17.3708 13.6157C17.7613 14.0062 17.7613 14.6394 17.3708 15.0299L16.4943 15.9063C14.383 18.0177 11.0404 18.2552 8.6517 16.4637L7.02224 15.2416C5.27871 13.9339 3.72989 12.3851 2.42224 10.6416L1.20014 9.01211C-0.591397 6.62339 -0.353846 3.28082 1.75751 1.16947Z",
    fill: "#00687F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGrey26);
export default __webpack_public_path__ + "static/media/phone-grey-26.3a6e0ea9682f36ac66ee53c01c3e205b.svg";
export { ForwardRef as ReactComponent };